export const CUI_URLS = ({
  CUI_ABOUT: 'https://www.archives.gov/cui/about',
  CFR_PART_2002: 'https://www.ecfr.gov/current/title-32/subtitle-B/chapter-XX/part-2002',
  GSA_ORDER_CIO_2103_2: 'https://www.gsa.gov/directives/files?file=2025-08%2FCIO%202103.2%2C%20Controlled%20Unclassified%20Information%20%28CUI%29%20Policy%20-%20April%202021%20%28admin%20edits%20to%20links%202025%29.pdf'
} as const);